import { Link as RouterLink } from "react-router-dom";
// material
import { styled } from "@mui/material/styles";
import { Box, Card, Link, Container, Typography, Stack } from "@mui/material";
// components
import Page from "../Page";
import ForgetPasswordForm from "../authentication/forget-password/ForgetPasswordForm";
import Logo from "../Logo";

// ----------------------------------------------------------------------
const RootStyle = styled(Page)(({ theme }) => ({
  minHeight: '100vh',
  background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 50%, ${theme.palette.secondary?.main || theme.palette.grey[600]} 100%)`,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(3),
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'0.05\'%3E%3Ccircle cx=\'30\' cy=\'30\' r=\'2\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
    animation: 'float 20s ease-in-out infinite',
  },
  '@keyframes float': {
    '0%, 100%': { transform: 'translateY(0px)' },
    '50%': { transform: 'translateY(-20px)' },
  },
}));

// ----------------------------------------------------------------------

export default function ForgetPassword() {
  return (
    <RootStyle title="Forget Password">
      <Container maxWidth="sm">
        <Card
          sx={{
            p: { xs: 3, sm: 4, md: 5 },
            boxShadow: (theme) => theme.customShadows?.z24 || '0 0 4px 0 rgba(145,158,171,0.24), 0 24px 48px 0 rgba(145,158,171,0.24)',
            borderRadius: 3,
            background: '#ffffff',
            border: (theme) => `1px solid ${theme.palette.grey[200]}`,
            minHeight: 'auto',
            maxHeight: '90vh',
            overflow: 'auto',
            position: 'relative',
            zIndex: 1,
          }}
        >
          <Stack sx={{ mb: 3, textAlign: 'center' }}>
            <Box sx={{ 
              mb: 2, 
              display: 'flex',
              justifyContent: 'center',
              '& img': { 
                maxWidth: '140px', 
                height: 'auto',
              } 
            }}>
              <Logo />
            </Box>
            <Typography 
              variant="h4" 
              gutterBottom 
              sx={{ 
                fontWeight: 700,
                mb: 0.5,
                background: 'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Forgot Password?
            </Typography>
            <Typography 
              variant="body1" 
              sx={{ 
                color: "text.secondary",
                fontWeight: 400,
              }}
            >
              Enter the email address associated with your account and we'll send you a link to reset your password.
            </Typography>
          </Stack>

          <ForgetPasswordForm />

          <Typography variant="subtitle2" sx={{ mt: 3, textAlign: "center" }}>
            Remembered your password?&nbsp;
            <Link to="/login" component={RouterLink} sx={{ color: 'primary.main', fontWeight: 600 }}>
              Login
            </Link>
          </Typography>
        </Card>
      </Container>
    </RootStyle>
  );
}
